import isCellTextFiltered from './isCellTextFiltered.js'
export default (filter, row) => {
  const id = filter.pivotId || filter.id
  return row[id] || row[id] === false ? isCellTextFiltered(row[id], filter.value) : false
}
